import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import './index.css';

const PieChart = ({title, data}) => {
  
  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: '100%',
    },
    tooltip: {
      useHTML: true 
    },
    title: {
      text: title,
      style: {
        fontWeight: '400',
        fontSize: '18px',
        fontFamily: 'Roboto',
        fontStyle: 'italic'
      },
      floating: false,
      margin: 15,
      align: "center",
      verticalAlign: "bottom",
      useHTML: true,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function() {
        return this.percentage.toFixed(1) + '%';
      }
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        colors: [
          '#5173BD',
          '#B2B3B5',
        ],
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
          //format: '{point.percentage:.1f} %',
        },
        showInLegend: true
      }
    },
    series: [{
      data: data,
    }]
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default PieChart;
